import { balancetimeModel } from './models/balancetime.js'
import { notFoundModel } from './models/dashboard.js'
import { eatModel } from './models/eat.js'
import { leaderboardModel } from './models/leaderboard.js'
import { meModel } from './models/me.js'
import { playtimeModel } from './models/playtime.js'
import { portalModel } from './models/portal.js'
import { profileModel } from './models/profile.js'
import { signatureToolModel } from './models/signaturetool.js'
import { urlShortenerModel } from './models/url-shortener.js'
import { worktimeModel } from './models/worktime.js'

export const routes = [
    portalModel.legacyRoute,
    profileModel.route,
    signatureToolModel.route,
    signatureToolModel.createRoute,
    signatureToolModel.editRoute,
    eatModel.route,
    balancetimeModel.route,
    worktimeModel.route,
    leaderboardModel.route,
    leaderboardModel.legacyRoute,
    playtimeModel.profileRoute,
    playtimeModel.formPreviewRoute,
    playtimeModel.campaignPreviewRoute,
    playtimeModel.surveyRoute,
    playtimeModel.legacySurveyRoute,
    playtimeModel.badgeRequestRoute,
    playtimeModel.publicProfileRoute,
    playtimeModel.legacyRoute,
    urlShortenerModel.route,
    urlShortenerModel.detailRoute,
    // Portal views, mounted at the root namespace. The /people exact route must
    // precede the /people/:id pattern route so exact paths win.
    portalModel.dashboardRoute,
    portalModel.tasksRoute,
    portalModel.eventsRoute,
    portalModel.peopleRoute,
    portalModel.peopleProfileRoute,
    portalModel.calendarRoute,
    portalModel.documentsRoute,
    portalModel.reportsRoute,
    portalModel.auditLogRoute,
    portalModel.settingsRoute,
    portalModel.settingsTabRoute,
    // The "Me" (Mina) area — one URL namespace. /me is exact; /me/:section
    // dispatches to the profile sections + tasks/worktime/documents views.
    meModel.route,
    meModel.sectionRoute,
    // Not-found route must be last, it has a catch-all matcher
    notFoundModel.route,
]

export const defaultPath = '/'
